/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：product_detail_pc（65 个 D 位坑位，14 个 C 位模块）。
 * 曝光事件上报模块编码（module.code，A.B.C）；点击事件上报坑位完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_DETAIL_PC_SPM_CODES = {
  accessory_recommendations: {
    code: `${sitePrefix}.product_detail_pc.accessory_recommendations`,
    add_to_cart_003: `${sitePrefix}.product_detail_pc.accessory_recommendations.add_to_cart_003`,
    add_to_cart_004: `${sitePrefix}.product_detail_pc.accessory_recommendations.add_to_cart_004`,
    add_to_cart_005: `${sitePrefix}.product_detail_pc.accessory_recommendations.add_to_cart_005`,
    add_to_cart_006: `${sitePrefix}.product_detail_pc.accessory_recommendations.add_to_cart_006`,
    favorite_003: `${sitePrefix}.product_detail_pc.accessory_recommendations.favorite_003`,
    favorite_004: `${sitePrefix}.product_detail_pc.accessory_recommendations.favorite_004`,
    favorite_005: `${sitePrefix}.product_detail_pc.accessory_recommendations.favorite_005`,
    favorite_006: `${sitePrefix}.product_detail_pc.accessory_recommendations.favorite_006`,
    preview_accessory_003: `${sitePrefix}.product_detail_pc.accessory_recommendations.preview_accessory_003`,
    preview_accessory_004: `${sitePrefix}.product_detail_pc.accessory_recommendations.preview_accessory_004`,
    preview_accessory_005: `${sitePrefix}.product_detail_pc.accessory_recommendations.preview_accessory_005`,
    preview_accessory_006: `${sitePrefix}.product_detail_pc.accessory_recommendations.preview_accessory_006`,
  },
  breadcrumb: {
    code: `${sitePrefix}.product_detail_pc.breadcrumb`,
    breadcrumb_item_01: `${sitePrefix}.product_detail_pc.breadcrumb.breadcrumb_item_01`,
    breadcrumb_item_02: `${sitePrefix}.product_detail_pc.breadcrumb.breadcrumb_item_02`,
  },
  color_variants: {
    code: `${sitePrefix}.product_detail_pc.color_variants`,
    select_variant_01: `${sitePrefix}.product_detail_pc.color_variants.select_variant_01`,
    select_variant_02: `${sitePrefix}.product_detail_pc.color_variants.select_variant_02`,
  },
  detail_navigation: {
    code: `${sitePrefix}.product_detail_pc.detail_navigation`,
    view_description: `${sitePrefix}.product_detail_pc.detail_navigation.view_description`,
    view_lens_details: `${sitePrefix}.product_detail_pc.detail_navigation.view_lens_details`,
    view_reviews: `${sitePrefix}.product_detail_pc.detail_navigation.view_reviews`,
    view_shipping_returns: `${sitePrefix}.product_detail_pc.detail_navigation.view_shipping_returns`,
    view_specifications: `${sitePrefix}.product_detail_pc.detail_navigation.view_specifications`,
  },
  frame_specifications: {
    code: `${sitePrefix}.product_detail_pc.frame_specifications`,
    material_entry: `${sitePrefix}.product_detail_pc.frame_specifications.material_entry`,
    shape_entry: `${sitePrefix}.product_detail_pc.frame_specifications.shape_entry`,
    toggle_measurement_unit: `${sitePrefix}.product_detail_pc.frame_specifications.toggle_measurement_unit`,
  },
  installment_information: {
    code: `${sitePrefix}.product_detail_pc.installment_information`,
    open_installment_details: `${sitePrefix}.product_detail_pc.installment_information.open_installment_details`,
  },
  lens_availability: {
    code: `${sitePrefix}.product_detail_pc.lens_availability`,
    toggle_lens_availability: `${sitePrefix}.product_detail_pc.lens_availability.toggle_lens_availability`,
  },
  product_gallery: {
    code: `${sitePrefix}.product_detail_pc.product_gallery`,
    select_image_01: `${sitePrefix}.product_detail_pc.product_gallery.select_image_01`,
    select_image_02: `${sitePrefix}.product_detail_pc.product_gallery.select_image_02`,
    select_image_03: `${sitePrefix}.product_detail_pc.product_gallery.select_image_03`,
    select_image_04: `${sitePrefix}.product_detail_pc.product_gallery.select_image_04`,
    select_image_05: `${sitePrefix}.product_detail_pc.product_gallery.select_image_05`,
    select_image_06: `${sitePrefix}.product_detail_pc.product_gallery.select_image_06`,
    toggle_dimensions_01: `${sitePrefix}.product_detail_pc.product_gallery.toggle_dimensions_01`,
    toggle_dimensions_02: `${sitePrefix}.product_detail_pc.product_gallery.toggle_dimensions_02`,
    try_on: `${sitePrefix}.product_detail_pc.product_gallery.try_on`,
  },
  product_summary: {
    code: `${sitePrefix}.product_detail_pc.product_summary`,
    favorite: `${sitePrefix}.product_detail_pc.product_summary.favorite`,
    view_reviews: `${sitePrefix}.product_detail_pc.product_summary.view_reviews`,
  },
  review_filters: {
    code: `${sitePrefix}.product_detail_pc.review_filters`,
    open_review_sort: `${sitePrefix}.product_detail_pc.review_filters.open_review_sort`,
    review_filter_option_01: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_01`,
    review_filter_option_02: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_02`,
    review_filter_option_03: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_03`,
    review_filter_option_04: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_04`,
    review_filter_option_05: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_05`,
    review_filter_option_06: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_06`,
    review_filter_option_07: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_07`,
    review_filter_option_08: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_08`,
    review_filter_option_09: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_09`,
    review_filter_option_10: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_10`,
    review_filter_option_11: `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_11`,
  },
  review_pagination: {
    code: `${sitePrefix}.product_detail_pc.review_pagination`,
    next_page: `${sitePrefix}.product_detail_pc.review_pagination.next_page`,
    page_number_01: `${sitePrefix}.product_detail_pc.review_pagination.page_number_01`,
    page_number_02: `${sitePrefix}.product_detail_pc.review_pagination.page_number_02`,
    page_number_03: `${sitePrefix}.product_detail_pc.review_pagination.page_number_03`,
    page_number_04: `${sitePrefix}.product_detail_pc.review_pagination.page_number_04`,
    page_number_05: `${sitePrefix}.product_detail_pc.review_pagination.page_number_05`,
    page_number_06: `${sitePrefix}.product_detail_pc.review_pagination.page_number_06`,
    previous_page: `${sitePrefix}.product_detail_pc.review_pagination.previous_page`,
  },
  review_results: {
    code: `${sitePrefix}.product_detail_pc.review_results`,
    mark_review_helpful_001: `${sitePrefix}.product_detail_pc.review_results.mark_review_helpful_001`,
    mark_review_helpful_002: `${sitePrefix}.product_detail_pc.review_results.mark_review_helpful_002`,
    mark_review_helpful_003: `${sitePrefix}.product_detail_pc.review_results.mark_review_helpful_003`,
    mark_review_helpful_004: `${sitePrefix}.product_detail_pc.review_results.mark_review_helpful_004`,
    mark_review_helpful_005: `${sitePrefix}.product_detail_pc.review_results.mark_review_helpful_005`,
  },
  services_guarantees: {
    code: `${sitePrefix}.product_detail_pc.services_guarantees`,
    open_fsa_hsa_details: `${sitePrefix}.product_detail_pc.services_guarantees.open_fsa_hsa_details`,
    toggle_services_guarantees: `${sitePrefix}.product_detail_pc.services_guarantees.toggle_services_guarantees`,
  },
  size_guide_entry: {
    code: `${sitePrefix}.product_detail_pc.size_guide_entry`,
    open_size_chart: `${sitePrefix}.product_detail_pc.size_guide_entry.open_size_chart`,
  },
} as const satisfies SpmPageCodes;
